/* eslint-disable camelcase */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthCredentials } from '../../models/AuthCredentials';
import { getSearchParamValue, parseJwt } from '../../utils';

export interface IAuthState {
  isAuth: boolean;
  authData: AuthCredentials;
  authForm: {
    error: string | null;
  };
  stepper: {
    currentStep: number;
  };
  logoutIsClicked: boolean;
}

const initialState: IAuthState = {
  isAuth: !!localStorage.getItem('access_token'),
  authData: {
    accessToken: localStorage.getItem('access_token') || '',
    refreshToken: localStorage.getItem('refresh_token') || '',
  },
  authForm: {
    error: null,
  },
  stepper: {
    currentStep: getSearchParamValue('step', window.location.search)
      ? +getSearchParamValue('step', window.location.search) || 0
      : 0,
  },
  logoutIsClicked: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setStep(state, { payload }: PayloadAction<number>) {
      state.stepper.currentStep = payload;
    },
    setFormError(state, { payload }: PayloadAction<string | null>) {
      state.authForm.error = payload;
    },
    logout(state) {
      localStorage.removeItem('access_token');
      state.authData.accessToken = '';
      localStorage.removeItem('refresh_token');
      state.authData.refreshToken = '';
      localStorage.removeItem('expiry');
      state.isAuth = false;
      state.logoutIsClicked = true;
    },
    setCredentials(state, { payload }: PayloadAction<{ accessToken: string; refreshToken: string }>) {
      state.authData.accessToken = payload.accessToken;
      localStorage.setItem('access_token', payload.accessToken);
      state.authData.refreshToken = payload.refreshToken;
      localStorage.setItem('refresh_token', payload.refreshToken);
      const jwt = parseJwt(payload.accessToken);
      if (jwt) {
        localStorage.setItem('expiry', JSON.stringify(+jwt.exp * 1000));
      }

      state.isAuth = true;
    },
    setTwoFactorAuthCredentials(state, { payload }: PayloadAction<{ accessToken: string; refreshToken: string }>) {
      state.authData.accessToken = payload.accessToken;
      state.authData.refreshToken = payload.refreshToken;
    },
  },
});

export default authSlice.reducer;
